import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createCustomerInvoice,
  editCustomerInvoice,
} from "store/general-info/customer/actions";
import * as yup from "yup";
import { LIST_TYPE_ID, modeDetail } from "./utils";

const DetailData = props => {
  const { isOpenModal, dataDetail, toggleModal, mode } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["customer"]);
  const { addToast } = useToasts();

  const customerInvoice = useSelector(state => state.customerInvoice);
  const { loading, data, error } = customerInvoice.detailCustomer;
  const { loading: loadingCreate } = customerInvoice.createCustomer;

  const schema = yup.object().shape({
    ma: yup
      .string()
      .required(t("form.validate.required", { title: t("form.ma") })),
    ten: yup
      .string()
      .required(t("form.validate.required", { title: t("form.ten") })),
    type_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.type_id") })),
    idno: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.idno") })),
    mst: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.mst`),
        })
      )
      .test("len", "Vui lòng nhập 10 hoặc 14 ký tự", val => {
        return val.length === 0 || val.length === 10 || val.length === 14;
      }),
    //   .required(t("form.validate.required", { title: t("form.mst") })),
    cty: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.cty") })),
    stknhang: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.stknhang") })),
    tnhang: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.tnhang") })),
    dchi: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.dchi") })),
    sdthoai: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.sdthoai") })),
    dctdtu: yup.string().email(
      t("form.validate.invalid", {
        title: t(`form.dctdtu`),
      })
    ),
    //   .required(t("form.validate.required", { title: t("form.dctdtu") })),
    fax: yup.string(),
    //   .required(t("form.validate.required", { title: t("form.fax") })),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { code: "", price: 0, id_vat: undefined, mst: "" },
  });

  useEffect(() => {
    if (isOpenModal) {
      reset();
      if (dataDetail) {
        setValue("ma", dataDetail.ma);
        setValue("ten", dataDetail.ten);
        setValue("idno", dataDetail.idno);
        setValue("mst", dataDetail.mst);
        setValue("cty", dataDetail.cty);
        setValue("stknhang", dataDetail.stknhang);
        setValue("tnhang", dataDetail.tnhang);
        setValue("dchi", dataDetail.dchi);
        setValue("sdthoai", dataDetail.sdthoai);
        setValue("dctdtu", dataDetail.dctdtu);
        setValue("fax", dataDetail.fax);
        setValue(
          "type_id",
          LIST_TYPE_ID.find(x => x.value === dataDetail.type_id)
        );
      }
    }
  }, [isOpenModal]);

  const onSubmit = values => {
    const data = {
      ...values,
      type_id: values.type_id.value,
    };
    switch (mode) {
      case modeDetail.CREATE:
        dispatch(createCustomerInvoice(data));
        break;
      case modeDetail.EDIT:
        dispatch(editCustomerInvoice(data, dataDetail.id));
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === modeDetail.CREATE && `Thêm khách hàng`}
            {mode === modeDetail.VIEW && `Chi tiết khách hàng`}
            {mode === modeDetail.EDIT && `Cập nhật khách hàng`}
          </ModalHeader>
          {loading ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="3"
                countButton="1"
                formClass="row-cols-1 row-cols-md-2"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1 row-cols-lg-2">
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.ma"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "ma",
                        t("placeholder.enter", {
                          title: t("form.ma"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading,
                        null,
                        control,
                        false,
                        false,
                        false,
                        null,
                        null,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.ten"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "ten",
                        t("placeholder.enter", {
                          title: t("form.ten"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateSelectField(
                        t("form.type_id"),
                        true,
                        errors,
                        "type_id",
                        t("placeholder.select", {
                          title: t("form.type_id"),
                        }),
                        mode === modeDetail.VIEW || loading,
                        control,
                        LIST_TYPE_ID,
                        "auto",
                        null,
                        false
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.idno"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "idno",
                        t("placeholder.enter", {
                          title: t("form.idno"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.mst"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "mst",
                        "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)",
                        register,
                        mode === modeDetail.VIEW || loading,
                        null,
                        control,
                        false,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.cty"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "cty",
                        t("placeholder.enter", {
                          title: t("form.cty"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.stknhang"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "stknhang",
                        t("placeholder.enter", {
                          title: t("form.stknhang"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.tnhang"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "tnhang",
                        t("placeholder.enter", {
                          title: t("form.tnhang"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.dchi"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "dchi",
                        t("placeholder.enter", {
                          title: t("form.dchi"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.sdthoai"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "sdthoai",
                        t("placeholder.enter", {
                          title: t("form.sdthoai"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.dctdtu"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "dctdtu",
                        t("placeholder.enter", {
                          title: t("form.dctdtu"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.fax"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "fax",
                        t("placeholder.enter", {
                          title: t("form.fax"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                {mode !== modeDetail.VIEW && (
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={loading}
                      >
                        <i className="bx bx-save label-icon"></i>
                        {mode === modeDetail.CREATE && t("form.save")}
                        {mode === modeDetail.EDIT && t("form.update")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </ModalFooter>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

DetailData.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  mode: PropTypes.string,
};

DetailData.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailData;
